import {isValidArray} from './common-utils';
import {DETAIL_SEO_PAGES, getPageName} from './seo-utils';

export const defaultRankListMweb = [
  'bestOffers',
  'propertyLayout',
  'goStays',
  'soldOutScreen',
  'whyIndiansBook',
  'previousBooking',
  'quickBookRatePlan',
  'inclusionCard',
  'offersForYou',
  'aboutHotel',
  'hostInfo',
  'hotelRules',
  'bookInclusive',
  'locationMap',
  'rnR',
  'qnaCard',
  'newFaqs',
  'similarHotels',
  'popularReviews',
];

export const defaultRankList = [
  'propertyLayout',
  'detailPreviousBooking',
  'roomSelection',
  'propertyHighlights',
  'nidhiBanner',
  'amenities',
  'foodWidget',
  'hostInfo',
  'rnR',
  'policy',
  'locationMap',
  'qnaCard',
  'newFaqs',
  'similarHotels',
  'popularReviews',
];

export enum pokusKeyDweb {
  DETAILS_SOLDOUT = 'DETAILS_SOLDOUT_DWEB',
  DETAILS_ALTACCO = 'DETAILS_ALTACCO_DWEB',
  DETAILS_PREM = 'DETAILS_PREM_DWEB',
  DETAILS_BUDGET = 'DETAILS_BUDGET_DWEB_F',
}

export enum pokusKeyMweb {
  DETAILS_SOLDOUT = 'DETAILS_SOLDOUT_MWEB',
  DETAILS_ALTACCO = 'DETAILS_ALTACCO_MWEB',
  DETAILS_PREM = 'DETAILS_PREM_MWEB',
  DETAILS_BUDGET = 'DETAILS_BUDGET_MWEB_F',
}

export const getComponentsCardForSeo = ({pageName: pageNameSlug = '', isDweb = true}) => {
  const pageName = getPageName(pageNameSlug);
  switch (pageName) {
    case DETAIL_SEO_PAGES.address:
      return ['locationMap', 'similarHotels'];

    case DETAIL_SEO_PAGES.rooms:
      return ['roomSelection', 'similarHotels'];

    case DETAIL_SEO_PAGES.photos:
      return ['photosCard', 'similarHotels'];

    case DETAIL_SEO_PAGES.review:
      if (isDweb) return ['rnR', 'similarHotels'];
      return ['rnRCard', 'similarHotels'];

    default:
      return isDweb ? defaultRankList : defaultRankListMweb;
  }
};

const getComponentsCardOrder = ({
  isDweb = true,
  isSeo = false,
  isSoldOut = false,
  isStarRating = false,
  isAltAcoo = false,
  pokusExpData = {},
} = {}) => {
  const finalDefaultRankList = isDweb ? defaultRankList : defaultRankListMweb;
  if (isSeo) {
    return finalDefaultRankList;
  }
  const pokusKey = isDweb ? pokusKeyDweb : pokusKeyMweb;
  let cardOrderKey = pokusKey.DETAILS_BUDGET;
  if (isSoldOut) cardOrderKey = pokusKey.DETAILS_SOLDOUT;
  else if (isAltAcoo) cardOrderKey = pokusKey.DETAILS_ALTACCO;
  else if (isStarRating) cardOrderKey = pokusKey.DETAILS_PREM;
  let pokusData = pokusExpData?.[cardOrderKey];
  try {
    pokusData = JSON.parse(pokusData);
  } catch (err) {
    pokusData = finalDefaultRankList;
  }
  return isValidArray(pokusData) ? pokusData : finalDefaultRankList;
};

export default getComponentsCardOrder;
